import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {
  // Codificar o src para lidar com espaços e caracteres especiais em URLs
  // Garantir que caminhos relativos começam com /
  const normalizedSrc = src ? (src.startsWith('http') ? src : src.startsWith('/') ? src : `/${src}`) : src;
  const encodedSrc = normalizedSrc ? (normalizedSrc.startsWith('http') ? normalizedSrc : encodeURI(normalizedSrc)) : normalizedSrc;

  return (
    <img
      src={encodedSrc}
      alt={alt}
      className={className}
      onError={(e) => {
        console.error('Erro ao carregar imagem:', encodedSrc);
        e.target.src = "/assets/images/no_image.png"
      }}
      {...props}
    />
  );
}

export default Image;
